import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "registration-steps-panel__counter" }
const _hoisted_2 = { class: "registration-steps-panel__title" }

import { RegistrationStepDto } from "@/account/models/authentication-models";
import { computed } from "vue";
import useAuthenticationFlows, { authenticationStep } from "@/account/composables/use-authentication-flows";


export default /*@__PURE__*/_defineComponent({
  __name: 'registration-steps-panel',
  setup(__props) {

const { containsFlowState } = useAuthenticationFlows();

const steps = computed(() => {
    const registrationStepPersonal: RegistrationStepDto = {
        codeName: "accountStepPersonal",
        displayName: "Registrační údaje",
        stepState: authenticationStep.value == "RegPersonal" ? "active" : "completed" // Personal is first step => is never displayed as future
    };
    const registrationStepVerification: RegistrationStepDto = {
        codeName: "accountStepVerification",
        displayName: containsFlowState("RegNewPass") ? "Ověření uživatele" : "Ověření telefonu",
        stepState:
            authenticationStep.value == "RegPinLog" || authenticationStep.value == "RegVerPhone"
                ? "active"
                : authenticationStep.value == "RegPersonal"
                ? "future"
                : "completed"
    };
    const steps = [registrationStepPersonal, registrationStepVerification];

    if (containsFlowState("RegNewPass")) {
        steps.push({
            codeName: "accountStepPass",
            displayName: "Nastavení hesla",
            stepState: "future" // Steps are not visible in password state => password step is always displayed as future
        });
    }

    return steps;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["registration-steps-panel", { 'registration-steps-panel--three-steps': steps.value.length > 2 }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `${step.codeName}-${i}`,
        class: _normalizeClass(["registration-steps-panel__item", step.stepState])
      }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(i + 1), 1),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "registration-steps-panel__tick" }, [
          _createElementVNode("div", { class: "registration-steps-panel__tick-icon" })
        ], -1)),
        _createElementVNode("div", _hoisted_2, _toDisplayString(step.displayName), 1)
      ], 2))
    }), 128))
  ], 2))
}
}

})